import { useT } from '../lib/i18n';

export function TablePreviewToggle({ pressed, onToggle }: { pressed: boolean; onToggle: () => void }) {
  const t = useT();
  return <button type="button" className="btn-ghost px-2 py-2 text-xs" aria-pressed={pressed}
    onClick={onToggle}>{t('match.tablePreview')}</button>;
}
